import axios from 'axios';

const getBlob = (url: string) =>
  axios.get<Blob>(url, {
    responseType: 'blob',
    timeout: 30000,
  });

export default getBlob;
